/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PracticeHub/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import React from 'react'
import Status from './Status/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PracticeHub({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/PracticeHub"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<div
  data-testid="PracticeHub.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-1NDsbe': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-1NDsbe': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-3-1NDsbe': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Practice Hub"
 color={dtColorsNeutral500}
 weight="medium"
 size="normal"
/>
<Status
  viewPath={`${viewPath}/Status`}
/>
</div>
{children}
</React.Fragment>)
}